<div *ngIf="graphVariables && graphVariables.length>0">
  <div class="mt-3 flex justify-content-center">
    <mat-chip-listbox class="me-5" aria-label="Interpolation Transform Selection" [(ngModel)]="interpolate" (ngModelChange)="onSelectInterpolate()" [disabled]="graphType==='profile'">
      <mat-chip-option color="warn" value="interpolation">Interpolation</mat-chip-option>
    </mat-chip-listbox>
    <mat-chip-listbox class="me-5" aria-label="Interpolation Transform Selection" [(ngModel)]="multiAnnualMean" (ngModelChange)="onSelectMultiAnnualMean()" [disabled]="disableMultiAnnual">
      <mat-chip-option color="accent" value="multiAnnualMean">Multi Annual Mean</mat-chip-option>
    </mat-chip-listbox>
    <mat-chip-listbox aria-label="Data Transform Selection" [(ngModel)]="dataTransform" (ngModelChange)="onSelectDataTransform()">
      <mat-chip-option value="normalize">Normalize</mat-chip-option>
      <mat-chip-option value="logTransform">Log Transform</mat-chip-option>
      <mat-chip-option value="sqrtTransform">Sqrt Transform</mat-chip-option>
    </mat-chip-listbox>
  </div>
</div>
